var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"btn-menu",class:{ 'dark-btn': _vm.dark }},_vm.$listeners),[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }